module.exports = __webpack_public_path__ + "img/qrcode.edb950ad.jpg";